import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import { store } from '../State';
import ApplicationRoot from './ApplicationRoot';

const appMain = document.getElementById('app-main');

const root = createRoot(appMain as HTMLElement);

export default root.render(
    <Provider store={store}>
        <Router basename={`${ROOT}`}>
            <ApplicationRoot />
        </Router>
    </Provider>,
);
